export default __webpack_public_path__ + "static/chat1-d9cd614bcf1ed7acde7a11c310142731.png";